import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const navigate = useNavigate();

  const handleCategoryClick = (slug: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => navigate(`/category/${slug}`), 150);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">视频分类浏览</h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm">海量影视资源按分类整理，轻松找到你想看的内容</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <div
              key={cat.id}
              className="flex flex-col items-center gap-3 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer group"
              onClick={() => handleCategoryClick(cat.slug)}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm font-medium text-foreground-900 mb-0.5">{cat.name}</h3>
                <p className="text-xs text-foreground-500">{cat.count}部</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}